import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { FloatingInfoHolder1eisb99cxddo9 as FloatingInfoHolder } from './FloatingInfoHolder.js.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FloatingInfoHolder$_get_preferredDirection_$ref_ex9o80(p0) {
  return () => p0.mc2_1;
}
function FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg(p0) {
  return (_this__u8e3s4) => {
    p0.mc2_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function MenuButton$_get_preferredDirection_$ref_wnuw33() {
  return (p0) => p0.cc4();
}
function MenuButton$_set_preferredDirection_$ref_aerfnf() {
  return (p0, p1) => {
    p0.dc4(p1);
    return Unit_instance;
  };
}
function MenuButton$_get_preferredDirection_$ref_wnuw33_0() {
  return (p0) => p0.cc4();
}
function MenuButton$_set_preferredDirection_$ref_aerfnf_0() {
  return (p0, p1) => {
    p0.dc4(p1);
    return Unit_instance;
  };
}
var MenuButtonClass;
function MenuButton() {
  if (MenuButtonClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.zc3_1 = new (FloatingInfoHolder())(this);
        this.lba(this.qb6_1.abf(ClickableSemantic_getInstance()));
        this.vb5_1.zb3_1 = 'button';
        this.vb5_1.jb4_1.v('kiteui-stack');
        this.vb5_1.jb4_1.v('clickable');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', (it) => {
            this.zc3_1.ec4();
            this.zc3_1.fc4();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            this.zc3_1.ec4();
            this.zc3_1.fc4();
            return Unit_instance;
          };
        }
        var tmp0 = this.vb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name = 'mouseenter';
        var tmp0_safe_receiver_0 = tmp0.xb3_1;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener(name, (it) => {
            if (!this.ac4_1) {
              this.zc3_1.ec4();
            }
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = tmp0.gb4_1['on' + name];
          var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + name;
          tmp0.gb4_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!this.ac4_1) {
              this.zc3_1.ec4();
            }
            return Unit_instance;
          };
        }
        this.ac4_1 = false;
        var tmp_5 = this;
        var tmp0_0 = this.zc3_1;
        var tmp_6 = KMutableProperty0();
        var tmp_7 = FloatingInfoHolder$_get_preferredDirection_$ref_ex9o80(tmp0_0);
        tmp_5.bc4_1 = getPropertyCallableRef('preferredDirection', 0, tmp_6, tmp_7, FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg(tmp0_0));
      }
      wb9(index, view) {
        super.wb9(index, view);
        Companion_instance.nbg(this, index, view);
      }
      dc4(_set____db54di) {
        var tmp0 = this.bc4_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MenuButton$_get_preferredDirection_$ref_wnuw33_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('preferredDirection', 1, tmp, tmp_0, MenuButton$_set_preferredDirection_$ref_aerfnf_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      cc4() {
        var tmp0 = this.bc4_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MenuButton$_get_preferredDirection_$ref_wnuw33();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('preferredDirection', 1, tmp, tmp_0, MenuButton$_set_preferredDirection_$ref_aerfnf());
        return tmp0.get();
      }
      gc4(createMenu) {
        this.zc3_1.oc2_1 = createMenu;
      }
    }
    initMetadataForClass($, 'MenuButton');
    MenuButtonClass = $;
  }
  return MenuButtonClass;
}
//region block: exports
export {
  MenuButton as MenuButton27en4jjgdkozz,
};
//endregion

//# sourceMappingURL=MenuButton.commonHtml.mjs.map
